import { REMOVE_TOKENS, SET_TOKENS } from "./actionTypes";

export const setTokens = (accessToken, refreshToken) => ({
    type: SET_TOKENS,
    payload: { accessToken, refreshToken },
});

export const removeTokens = () => ({
    type: REMOVE_TOKENS,
});